
















































































import Vue from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { AuthV1ProfileRegisterRequest, Profile } from '@/requests/mainApi';
import AuthFormContainer from '@/components/modules/Auth/AuthFormContainer.vue';
import UiInput from '@/components/ui/UiInput.vue';
import UiLabel from '@/components/ui/UiLabel.vue';
import UiCheckbox from '@/components/ui/UiCheckbox.vue';
import VueDatepicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ru';
import { masks } from '@/utils/plugins/inputMask';
import UiButton from '@/components/ui/UiButton.vue';
import { TranslateResult } from 'vue-i18n';

interface Field {
  value: string;
  isValid: boolean;
  errorMessage: TranslateResult;
}

interface Data {
  loading: boolean;
  isValid: boolean;
  name: Field;
  lastName: Field;
  patronymic: Field;
  email: Field;
  birthDate: Field;
  pdAgreement: boolean;
  promoAccept: boolean;
}

interface Methods {
  validate: () => void;
  validateName: () => boolean;
  validateLastName: () => boolean;
  validateEmail: () => boolean;
  validateBirthDate: () => boolean;
  analyticsSend: (key: string) => void;
  registerData: () => Promise<void>;
  getUserData: () => Promise<Profile>;
  setUserData: (data: { [key: string]: any }) => void;
  registerProfile: (variables: AuthV1ProfileRegisterRequest) => Promise<Profile>;
  setAccessToken: (token: string) => void;
  setIsFromConfirmEmail: (value: boolean) => void;
  getPPDAndTPDLinks: () => void;
}

interface Computed {
  emailLabelText: string;
  temporaryAccessToken: string;
  isFromConfirmEmail: boolean;
}

interface Props {
  timeToOpenPage: number;
  firstStep: () => void;
  emailConfirmStep: () => void;
}

export default Vue.extend({
  name: 'SignInNameStep',
  components: {
    AuthFormContainer,
    UiInput,
    UiLabel,
    UiCheckbox,
    UiButton,
    VueDatepicker,
  },
  props: {
    timeToOpenPage: {
      type: Number,
      required: true,
    },
    firstStep: {
      type: Function,
    },
  },
  data() {
    return {
      name: {
        value: '',
        isValid: false,
        errorMessage: '',
      },
      lastName: {
        value: '',
        isValid: false,
        errorMessage: '',
      },
      patronymic: {
        value: '',
        isValid: false,
        errorMessage: '',
      },
      birthDate: {
        value: '',
        isValid: false,
        errorMessage: '',
      },
      email: {
        value: '',
        isValid: false,
        errorMessage: '',
      },
      pdAgreement: false,
      promoAccept: false,
      loading: true,
      isValid: true,
      masks,
    };
  },
  computed: {
    emailLabelText() {
      return this.email.errorMessage || this.$t('auth.signIn.nameStep.email');
    },
    ...mapGetters([
      'temporaryAccessToken',
      'isFromConfirmEmail',
      'PPDAndTPDLinks'
    ]),
  },
  watch: {
    name: {
      handler(field) {
        this.setUserData({ name: field.value });

        this.validate();
      },
      deep: true,
    },
    lastName: {
      handler(field) {
        this.setUserData({ lastName: field.value });

        this.validate();
      },
      deep: true,
    },
    email: {
      handler(field) {
        this.setUserData({ email: field.value });

        this.validate();
      },
      deep: true,
    },
    patronymic: {
      handler(field) {
        this.setUserData({ patronymic: field.value });

        this.validate();
      },
      deep: true,
    },
    birthDate: {
      handler(field) {
        this.setUserData({ birthday: field.value });

        this.validate();
      },
      deep: true,
    },
    pdAgreement: {
      handler(field) {
        this.validate();
      }
    }
  },
  created() {
    this.setAccessToken(this.temporaryAccessToken);
    this.getUserData()
      .then(res => {
        const userHasName = res?.firstName?.length;
        const userHasLastName = res?.lastName?.length;
        const userHasEmail = res?.email?.length;
        const userHasBirthDate = res?.birthday?.length;

        if (userHasName && userHasLastName && userHasEmail && userHasBirthDate && res?.isConfirmedEmail) {
          this.$router.push('/');
        }

        this.name.value = res?.firstName || '';
        this.lastName.value = res?.lastName || '';
        this.email.value = res?.email || '';
        this.birthDate.value = res?.birthday?.split('-').reverse().join('.') || '';
        this.validate();
      })
      .finally(() => {
        setTimeout(() => {
          this.loading = false;
        }, 500);
      });
  },
  mounted() {
    this.getPPDAndTPDLinks();
  },
  methods: {
    validate() {
      this.isValid = this.validateLastName() &&
        this.validateName() &&
        this.validateEmail() &&
        this.validateBirthDate() &&
        !!this.pdAgreement
    },
    validateName() {
      const isSet = this.name.value.length > 0;
      const hasNumbers = /\d/.test(this.name.value);
      this.name.isValid = isSet && !hasNumbers;

      return isSet && !hasNumbers;
    },
    validateLastName() {
      const isSet = this.lastName.value.length > 0;
      const hasNumbers = /\d/.test(this.lastName.value);
      this.lastName.isValid = isSet && !hasNumbers;

      return isSet && !hasNumbers;
    },
    validateEmail() {
      const isSet = this.email.value.length > 0;
      const isEmailFormat =
        /^(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\]\\.,;:\s@\\"]+\.)+[^<>()[\]\\.,;:\s@\\"]{2,})$/i.test(
          this.email.value
        );
      this.email.isValid = isSet && isEmailFormat;

      if (!isSet) {
        this.email.errorMessage = '';
        return isSet && isEmailFormat;
      }

      if (!isEmailFormat) {
        this.email.errorMessage = this.$t('auth.signIn.nameStep.errors.emailIsInvalid');
        return isSet && isEmailFormat;
      }

      this.email.errorMessage = '';
      return isSet && isEmailFormat;
    },
    validateBirthDate() {
      const isSet = !!this.birthDate.value;
      this.birthDate.errorMessage = isSet ? '' : this.$t('auth.signIn.nameStep.errors.date');
      return isSet;
    },
    analyticsSend(key: string) {
      this.$analytics.logEvent(key, {
        screen: 'registration',
        time: Math.round((new Date().getTime() - this.timeToOpenPage) / 1000),
        name: Boolean(this.name),
      });
    },
    async registerData(): Promise<void> {
      this.validate();
      if (!this.isValid) {
        return;
      }

      this.analyticsSend('get_name');
      this.setAccessToken(this.temporaryAccessToken);
      this.setIsFromConfirmEmail(false);
      await this.registerProfile({
        data: {
          firstName: this.name.value,
          email: this.email.value,
          lastName: this.lastName.value,
          patronymic: this.patronymic.value,
          birthday: this.birthDate.value,
          pdAgreement: this.pdAgreement,
          promoAccept: this.promoAccept
        },
      }).then(profile => {
        if (!profile.isConfirmedEmail) {
          this.$emit('emailConfirmStep');
          return;
        }
      });
    },
    ...mapActions(['registerProfile', 'getUserData', 'getPPDAndTPDLinks']),
    ...mapMutations(['setAccessToken', 'setIsFromConfirmEmail', 'setUserData']),
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
